import PandadocService from './pandadoc_service';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/pandadoc', {
        template: `
          <h3 ng-if="!error">Please wait...</h3>
          <h3 ng-if="error">{{error}}: {{error_description}}</h3>
        `,
        controller: 'PandadocController'
    });
})
.service('PandadocService', PandadocService)
.controller('PandadocController', function($window, $location, $scope, PandadocService) {
  let params = $location.search();

  if (params.code) {
    console.log('Exchanging Pandadoc code for token...');
    PandadocService.tokenFromCode(params.code).then((data) => {
      console.log('Got token: ', data);
      PandadocService.storeToken(data);

      if (sessionStorage.getItem('accountRedirect')) {
        $window.location.replace(sessionStorage.getItem('accountRedirect'));
        sessionStorage.removeItem('accountRedirect');
      } else {
        $window.location.replace('/');
      }
    }).catch((err) => {
      console.error('Unable to get token', err);
      $window.location.replace('/');
    });
  } else {
    $scope.error = params.error;
    $scope.error_description = params.error_description;
  }

});



// WEBPACK FOOTER //
// ./views/pandadoc/pandadoc_controller.js